var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgWand = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A5A5A5",
    fillRule: "evenodd",
    d: "M17.84 7.476c.25 0 .489.1.664.279l3.701 3.75a.94.94 0 0 1-.003 1.32l-16.85 16.9a.94.94 0 0 1-1.327 0l-3.75-3.75a.94.94 0 0 1 0-1.326L17.174 7.75a.94.94 0 0 1 .666-.274M2.263 25.313l2.424 2.423 15.53-15.576-2.384-2.417z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A5A5A5",
    fillRule: "evenodd",
    d: "M13.424 11.5a.937.937 0 0 1 1.326 0l3.75 3.75a.937.937 0 0 1-1.326 1.326l-3.75-3.75a.937.937 0 0 1 0-1.326M29.725.275a.94.94 0 0 1 0 1.325L24.1 7.225A.937.937 0 1 1 22.775 5.9L28.4.275a.937.937 0 0 1 1.325 0",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#A5A5A5",
    fillRule: "evenodd",
    d: "M22.775.275a.937.937 0 0 1 1.325 0L29.725 5.9A.938.938 0 0 1 28.4 7.225L22.775 1.6a.94.94 0 0 1 0-1.325M29.725 19.025a.937.937 0 0 1 0 1.325L24.1 25.975a.937.937 0 0 1-1.325-1.325l5.625-5.625a.937.937 0 0 1 1.325 0",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#A5A5A5",
    fillRule: "evenodd",
    d: "M22.775 19.025a.937.937 0 0 1 1.325 0l5.625 5.625a.937.937 0 0 1-1.325 1.325l-5.625-5.625a.937.937 0 0 1 0-1.325M12.85.275a.94.94 0 0 1 0 1.325L7.225 7.225A.937.937 0 1 1 5.9 5.9L11.525.275a.937.937 0 0 1 1.325 0",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#A5A5A5",
    fillRule: "evenodd",
    d: "M5.9.275a.937.937 0 0 1 1.325 0L12.85 5.9a.938.938 0 0 1-1.325 1.325L5.9 1.6a.937.937 0 0 1 0-1.325",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWand);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wand.2e2a6f01.svg";